import * as React from 'react';
import { connect } from 'react-redux';
import { IconBuilder16 } from '@cian/ui-kit';
import { BuilderLabel } from '../../components/BuilderLabel';

import { SIZE_4, SIZE_8, SIZE_44, SIZE_60, SIZE_80, SIZE_AUTO } from '../../constants/sizes';

import { Link } from '../../components/Link';
import { Container } from '../../components/Container';
import { Image } from '../../components/Image';
import { BuilderStatusContainer } from '../../containers/BuilderStatusContainer';
import { Text } from '../../components/Text';
import { IBuilder, ISeller } from '../../types/newbuilding';
import { TTypedThunkDispatch } from '../../types/thunk';
import { trackingActionToCardDeveloperLogo, trackingActionToCardDeveloperName } from '../../actions/analytics';
import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';

interface IBuilderInfoComponentOwnProps {
  builders: IBuilder[];
  sellers?: ISeller[] | null;
  newbuildingId: number;
  fromDeveloperPropsCount: number;
}

interface IBuilderInfoComponentDispatchProps {
  trackingToCardDeveloperLogo(): void;
  trackingToCardDeveloperName(): void;
}

export type TBuilderInfoComponentProps = IBuilderInfoComponentOwnProps & IBuilderInfoComponentDispatchProps;

export function BuilderInfoComponent(props: TBuilderInfoComponentProps) {
  const {
    builders = [],
    sellers,
    newbuildingId,
    fromDeveloperPropsCount,
    trackingToCardDeveloperLogo,
    trackingToCardDeveloperName,
  } = props;
  const isAloneBuilder = builders.length === 1;

  if (!builders.length) {
    return null;
  }

  return (
    <>
      {isAloneBuilder && (
        <div data-mark="AloneBuilder" data-testid="AloneBuilder">
          <Link url={builders[0].url} target="blank">
            <Container
              display="flex"
              borderRadius={2}
              padding={SIZE_8}
              borderColor="gray_0"
              borderStyle="solid"
              justifyContent="center"
              alignItems="center"
              borderTopWidth={1}
              borderRightWidth={1}
              borderBottomWidth={1}
              borderLeftWidth={1}
              width={SIZE_80}
              minHeight={SIZE_60}
            >
              <Container width={SIZE_AUTO}>
                {builders[0].logoUrl && builders[0].name ? (
                  <Image
                    alt={`Логотип застройщика ${builders[0].name}`}
                    src={`https://www.cian.ru${builders[0].logoUrl}`}
                    onClick={trackingToCardDeveloperLogo}
                    noEmptyImage
                  />
                ) : (
                  <Container
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width={SIZE_60}
                    height={SIZE_44}
                    backgroundColor="gray_0"
                  >
                    <IconBuilder16 />
                  </Container>
                )}
              </Container>
            </Container>
            <Container margin={`${SIZE_4} 0 ${SIZE_4} 0`} onClick={trackingToCardDeveloperName}>
              <Text color="blue" colorHovered="red">
                {builders[0].name}
              </Text>
            </Container>
          </Link>
        </div>
      )}
      <BuilderLabel text="Застройщик" dataMark="BuilderLabel" data-testid="BuilderLabel" />
      {!isAloneBuilder && (
        <div>
          {builders.map((builder, index) => {
            const notLast = index + 1 < builders.length;

            return (
              <Text
                display="inline-block"
                color="blue"
                colorHovered="red"
                key={`${builder}${index}`}
                dataMark="Builder"
              >
                <Link url={builders[index].url} target="blank" onClick={trackingToCardDeveloperName}>
                  <>
                    {`${builder.name}${notLast ? ',' : ''}`}
                    {notLast ? NO_BREAK_SPACE : null}
                  </>
                </Link>
              </Text>
            );
          })}
        </div>
      )}
      <BuilderStatusContainer
        sellers={sellers}
        newbuildingId={newbuildingId}
        fromDeveloperPropsCount={fromDeveloperPropsCount}
      />
    </>
  );
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    trackingToCardDeveloperLogo() {
      dispatch(trackingActionToCardDeveloperLogo());
    },
    trackingToCardDeveloperName() {
      dispatch(trackingActionToCardDeveloperName());
    },
  };
}
export const BuilderInfo = connect<null, IBuilderInfoComponentDispatchProps, IBuilderInfoComponentOwnProps>(
  null,
  mapDispatchToProps,
)(BuilderInfoComponent);
